import EventBus from "@/common/EventBus";
import badger from "_lib/Badger";
import UpdateHandler from "./components/updateHandler";
const DEFAULT_DOM_HEIGHT = 42
let dragEnterDoms = []
let dragDirection = null
let dragFolderDirection = null
let isOpenTimeout = null
const openFolderIds = new Set()
const getInfolder = (attrElement) => {
  const folderEl = attrElement.closest('.cpt-folder-wrapper[data-folder-id]');
  return folderEl;
}
export default {
  methods: {
    getTargetRoom(attrElement){
      const closestRoom = attrElement.closest('.cpt-shortcut-block-wrapper[data-room-id]');
      if (!closestRoom) return {};
      const room_id = closestRoom.getAttribute('data-room-id');
      if (room_id) {
        const room = this.room_list.find(room => room.room_id === room_id);
        return {
          room,
          room_id,
        }
      }
      return {};
    },
    getTargetFolder(attrElement){
      const closestFolder = attrElement.closest('.cpt-folder-wrapper[data-folder-id]');
      if (!closestFolder) return {};
      const folder_id = closestFolder.getAttribute('data-folder-id');
      if (folder_id) {
        const folder = this.folders.find(folder => folder.folder_id === folder_id);
        return {
          folder,
          folder_id,
        }
      }
      return {};
    },
    handleClickRoom(event, attrElement){
      const { room } = this.getTargetRoom(attrElement);
      if (!room) return;
      const tempType = attrElement.getAttribute('data-temp-type');
      if (tempType === 'invite' && !room.is_public_room) {
        this.handlePushBack()
      } else {
        EventBus.$jump(room, 'room-shortcut')
      }
    },
    handleClickFolder(event, attrElement) {
      clearTimeout(isOpenTimeout);
      const folderEl = getInfolder(attrElement);
      if (!folderEl) return;
      
      const folder_id = folderEl.getAttribute('data-folder-id');
      const isOpen = !folderEl.classList.contains('open');
      
      const folderData = this.folders.find(v => v.folder_id === folder_id);
      if (folderData) {
        UpdateHandler.changeFolderOpen(
          folder_id, 
          isOpen, 
          this.folderInstances.get(folder_id), 
          folderData
        );
      }
    },
    getUnreadState(room) {
      const v = this.$unread.getUnreadState({room_id: room.room_id})
      !process.env.IS_CLIENT && badger.updateRoomUnreadCount(v.redCount, room.room_id)
      return v
    },
    getFolderUnreadState(folder) {
      let obj = {
        redCount: 0,
        showRedPoint: false,
      };
      folder.rooms.forEach((v) => {
        let { redCount, showRedPoint } = this.$unread.getUnreadState({
          room_id: v.room_id,
        });
        !process.env.IS_CLIENT && badger.updateRoomUnreadCount(redCount, v.room_id);
        obj.redCount += redCount;
        obj.showRedPoint = showRedPoint || obj.showRedPoint;
      });
      return obj;
    },
    handleCtxmenuFolder(event, attrElement) {
      event.preventDefault();
      event.stopPropagation();
      const folderEl = getInfolder(attrElement);
      if (!folderEl) return;
      const folder_id = folderEl.getAttribute('data-folder-id');
      const folderData = this.folders.find(v => v.folder_id === folder_id);
      if (!folderData) return;
      const unreadState = this.getFolderUnreadState(folderData);
      let hideClearRed = !unreadState.showRedPoint && !unreadState.redCount;
      let contextMenuOptions = {
        groups: [
          {
            items: [
              {
                component: "menu-button",
                hidden: hideClearRed,
                data: {
                  label: "标记为已读",
                },
                onClick: () => {
                  folderData.rooms.forEach((v) => {
                    EventBus.$emit("Update_Unread_States", {
                      room_id: v.room_id,
                    });
                  });
                },
              },
              {
                component: "menu-button",
                hidden: folderEl.dataset.index == 0,
                data: {
                  label: "移动至首位",
                },
                onClick: () => {
                  EventBus.$emit("Set_Room_Top", folderData.folder_id);
                },
              },
              {
                component: "menu-button",
                data: {
                  label: "文件夹设置",
                },
                onClick: () => {
                  EventBus.$dynamic("FolderConfig", folderData);
                },
              },
            ],
          },
        ],
        event,
      };
      this.$contextmenu(contextMenuOptions);
    },
    handleCtxmenuRoom(event, attrElement){
      event.preventDefault();
      event.stopPropagation();
      const { room, room_id } = this.getTargetRoom(attrElement);
      if (!room) return;
      const unreadState = this.getUnreadState(room);
      const tempType = attrElement.getAttribute('data-temp-type');
      const index = -1
      const folderEl = attrElement.closest('.cpt-folder-wrapper[data-folder-id]');
      const folder_id = folderEl ? folderEl.getAttribute('data-folder-id') : null;
      this.shortCutsContextMenuHandler({room, unreadState}, !!tempType, !!folder_id, event, index)
    },
    handleDragstartRoom(event, attrElement) {
      event.stopPropagation();
      if (!this.canDragRoom) return;
      const { room, room_id } = this.getTargetRoom(attrElement);
      if (!room) return;
      const folderEl = getInfolder(attrElement);
      let type = `dragleroom/${room_id}` + (folderEl ? ':' + folderEl.getAttribute('data-folder-id') : '')
      event.dataTransfer.setData(type, '')
      event.dataTransfer.effectAllowed = 'move'
    },
    handleDragenterRoom(event, attrElement) {
      event.stopPropagation();
      if (!this.canDragRoom) return;
      const { room } = this.getTargetRoom(attrElement);
      if (!room) return;
      dragEnterDoms.push(event.target)
      let type = event.dataTransfer.types.find(v => v.indexOf('dragle') === 0)
      if (type) {
        event.preventDefault();
      }
    },
    handleDragoverRoom(e, attrElement) {
      e.stopPropagation();
      if (!this.canDragRoom) return;
      const { room } = this.getTargetRoom(attrElement);
      if (!room) return;
      if (dragEnterDoms.length === 0) return
      let type = e.dataTransfer.types.find(v => v.indexOf('dragle') === 0)
      if (!type) return
      // 文件夹不能拖入文件夹内的房间
      const folderEl = getInfolder(attrElement);
      if (type.includes('draglefolder') && folderEl) return

      // 拖拽的房间和放置的房间一样不做处理
      const ids = type.split('/')[1].split(':')
      if (ids.includes(room.room_id)) {
        return;
      }
      const shortcutBlock = attrElement.querySelector('.shortcut-block')
      if (!shortcutBlock) return
      let parentRect = shortcutBlock.getBoundingClientRect();
      let offsetY = e.clientY - parentRect.top; // 直接获取offsetY可能会拿到子元素的offsetY，导致闪动
      const domHeight = shortcutBlock.clientHeight || DEFAULT_DOM_HEIGHT
      // 文件夹内的房间不能创建文件夹，拖拽的是文件夹也不能创建文件夹
      if (!folderEl && !type.includes('draglefolder')) {
        // 根据鼠标位置判断是添加在上方,下方,还是文件夹
        if (offsetY < domHeight / 5) {
          dragDirection = 'up'
        } else if (offsetY > domHeight / 5 * 4) {
          dragDirection = 'down'
        } else {
          dragDirection = 'virtual-folder'
        }
      } else {
        // 根据鼠标位置判断是添加在上方,下方
        if (offsetY < domHeight / 2) {
          dragDirection = 'up'
        } else {
          dragDirection = 'down'
        }
      }
      // 通知文件夹当前dragDirection改变为down，目前仅有down需要做样式处理
      UpdateHandler.updateDragRoom(room.room_id, dragDirection)
      e.preventDefault();
    },
    handleDragleaveRoom(e, attrElement) {
      e.stopPropagation();
      if (!this.canDragRoom) return;
      dragEnterDoms = dragEnterDoms.filter(v => v !== e.target)
      if (dragEnterDoms.length > 0) {
        return
      }
      const { room_id } = this.getTargetRoom(attrElement);
      if (!room_id) return;
      dragDirection = null
      UpdateHandler.updateDragRoom(room_id, dragDirection)
    },
    handleDropRoom(e, attrElement) {
      e.stopPropagation();
      e.preventDefault();
      if (!this.canDragRoom) return;
      const { room } = this.getTargetRoom(attrElement);
      if (!room) return;
      let type = e.dataTransfer.types.find(v => v.indexOf('dragle') === 0)
      e.dataTransfer.clearData()
      let cur_ids = {}
      const infolder = getInfolder(attrElement);
      if (infolder) {
        cur_ids.in_id = room.room_id
        cur_ids.out_id = infolder.getAttribute('data-folder-id')
      } else {
        cur_ids.out_id = room.room_id
      }
      let origin_ids = {}, idStr = type.split('/')[1]
      if (idStr.includes(':')) {
        origin_ids.out_id = idStr.split(':')[1]
        origin_ids.in_id = idStr.split(':')[0]
      } else {
        origin_ids.out_id = idStr
      }
      
      if (infolder && origin_ids.out_id === infolder.getAttribute('data-folder-id')) {
        // 同一文件夹内排序
        this.moveFolder(cur_ids, origin_ids, dragDirection, true);
      } else if (dragDirection === 'virtual-folder') {
        this.createFolder(cur_ids, origin_ids);
      } else {
        this.moveFolder(cur_ids, origin_ids, dragDirection);
      }
      dragDirection = null
      UpdateHandler.updateDragRoom(room.room_id, dragDirection)
    },
    handleDragstartFolder(e, attrElement) {
      e.stopPropagation();
      if (!this.canDragRoom) return;
      const folderEl = getInfolder(attrElement);
      if (!folderEl) return;
      const folder_id = folderEl.getAttribute('data-folder-id');
      e.dataTransfer.setData(`draglefolder/${folder_id}`, {});
      e.dataTransfer.effectAllowed = "move";
    },
    handleDragenterFolder(event, attrElement) {
      event.stopPropagation();
      if (!this.canDragRoom) return;
      const folderEl = getInfolder(attrElement);
      if (!folderEl) return;
      const folder_id = folderEl.getAttribute('data-folder-id');
      
      let type = event.dataTransfer.types.find(v => v.indexOf('dragle') === 0);
      if (type) {
        event.preventDefault();
      }
    },

    handleDragoverFolder(e, attrElement) {
      e.stopPropagation();
      if (!this.canDragRoom) return;
      const folderEl = getInfolder(attrElement);
      if (!folderEl) return;
      const folder_id = folderEl.getAttribute('data-folder-id');
      
      let type = e.dataTransfer.types.find(v => v.indexOf('dragle') === 0);
      if (!type) return;
      
      // 拖拽的文件夹和放置的文件夹一样不做处理
      const ids = type.split('/')[1].split(':');
      if (ids.length === 1 && ids[0] === folder_id) {
        return;
      }
      
      const folderInstance = this.folderInstances.get(folder_id);
      if (!folderInstance) return;
      
      
      let parentRect = folderEl.getBoundingClientRect();
      let offsetY = e.clientY - parentRect.top;
      let domHeight = folderEl.clientHeight || 42;
      
      // 文件夹内不能拖入文件夹
      if (!type.includes("draglefolder") && !folderInstance.data.isOpen) {
        // 根据鼠标位置判断是添加在上方,下方,还是文件夹
        if (offsetY < domHeight / 5) {
          dragFolderDirection = "up";
        } else if (offsetY > (domHeight / 5) * 4) {
          dragFolderDirection = "down";
        } else {
          dragFolderDirection = "virtual-folder";
        }
      } else {
        // 根据鼠标位置判断是添加在上方,下方
        if (offsetY < domHeight / 2) {
          dragFolderDirection = "up";
        } else {
          dragFolderDirection = "down";
        }
      }
      
      // 更新DOM中的dragDirection类
      UpdateHandler.updateFolderDragDirection(folder_id, dragFolderDirection);
      
      e.preventDefault();
    },

    handleDragleaveFolder(e, attrElement) {
      e.stopPropagation();
      if (!this.canDragRoom) return;
      const folderEl = getInfolder(attrElement);
      if (!folderEl) return;
      const folder_id = folderEl.getAttribute('data-folder-id');
      
      const folderInstance = this.folderInstances.get(folder_id);
      if (folderInstance) {
        dragFolderDirection = null;
        UpdateHandler.updateFolderDragDirection(folder_id, null);
      }
    },

    handleDropFolder(e, attrElement) {
      e.stopPropagation();
      e.preventDefault();
      if (!this.canDragRoom) return;
      const folderEl = getInfolder(attrElement);
      if (!folderEl) return;
      const folder_id = folderEl.getAttribute('data-folder-id');
      
      const folderInstance = this.folderInstances.get(folder_id);
      if (!folderInstance) return;
      
      let type = e.dataTransfer.types.find(v => v.indexOf('dragle') === 0);
      if (!type) return;
      
      e.dataTransfer.clearData();
      
      let cur_ids = {
        out_id: folder_id,
      };
      
      let origin_ids = {}, 
          idStr = type.split("/")[1];
          
      if (idStr.includes(":")) {
        origin_ids.out_id = idStr.split(":")[1];
        origin_ids.in_id = idStr.split(":")[0];
      } else {
        origin_ids.out_id = idStr;
      }
      
      if (dragFolderDirection === "virtual-folder") {
        // 移入文件夹
        this.InFolder(cur_ids, origin_ids);
      } else {
        // 移动到文件夹上方或下方
        this.moveFolder(cur_ids, origin_ids, dragFolderDirection);
      }
      
      dragFolderDirection = null;
      UpdateHandler.updateFolderDragDirection(folder_id, null);
    },
  }
}